
const ITSupportIntro = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* 動画セクション */}
        <div className="relative w-full h-[400px] rounded-2xl overflow-hidden mb-12">
          <video 
            className="w-full h-full object-cover"
            autoPlay 
            muted 
            playsInline 
            loop
          >
            <source src="/image/it-support-mv.mov" type="video/mp4" />
            動画を再生するにはvideoタグをサポートしたブラウザが必要です。
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
          <p className="text-gray-700 text-sm leading-relaxed mb-6">
            新型コロナウイルス感染症が事業環境に影響を与えている企業様向けに、IT導入補助金の特別枠C類型が設置されました。<br />
            MSKは提案から公開・運営まで全てサポートいたします。<br />
            コロナに負けない仕組みづくりを一緒にさせてください！
          </p>
          <a
            href="https://www.it-hojo.jp/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 text-[#5DAA68] hover:text-[#3F6844] text-sm font-bold transition-colors cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            補助金公式サイトはこちら
          </a>
        </div>
      </div>
    </section>
  );
};

export default ITSupportIntro;
